import * as React from "react";
import { Container, Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import Pricing from "../components/homepage/Pricing";

export default function PricingPage() {
  const { t } = useTranslation();
  return (
    <Container maxWidth="lg" sx={{ py: { xs: 4, sm: 6 } }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h3" sx={{ fontWeight: 700, letterSpacing: -0.5 }}>
          {t("legal.pricing.title")}
        </Typography>
        <Typography sx={{ color: "text.secondary", mt: 1 }}>
          {t("legal.pricing.subtitle")}
        </Typography>
      </Box>
      <Pricing />
    </Container>
  );
}

